import { gql } from '@/features/graphql/generated'

export const ShiftCloseoutPreviewQuery = gql(/* GraphQL */ `
    query ShiftCloseoutPreview {
        currentTime
        shiftCloseoutPreview {
            cashTransactions {
                amount {
                    amount
                    currency
                }
                note
                transactedAt
                type
            }
            currency
            orderCount
            paymentTotals {
                amount {
                    amount
                    currency
                }
                paymentType
            }
            receiptCount
            totalAmount {
                amount
                currency
            }
        }
    }
`)

export const ShiftCloseoutsQuery = gql(/* GraphQL */ `
    query ShiftCloseouts {
        shiftCloseouts {
            closedAt
            closedByName
            totalAmount {
                amount
                currency
            }
            uuid
        }
    }
`)

export const CashTransactionsQuery = gql(/* GraphQL */ `
    query CashTransactions {
        cashRegisterBalance {
            amount
            currency
        }
        cashTransactionTotals {
            deposits {
                amount
                currency
            }
            difference {
                amount
                currency
            }
            withdrawals {
                amount
                currency
            }
        }
        cashTransactions {
            amount {
                amount
                currency
            }
            id
            note
            transactedAt
            type
        }
    }
`)
